module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTM0NC41IDEyOGE2NCA2NCAwIDAgMSA1Ny4zIDM1LjRMNDQ4IDI1Nmg0NDhhNjQgNjQgMCAwIDEgNjQgNjR2NTEyYTY0IDY0IDAgMCAxLTY0IDY0SDEyOGE2NCA2NCAwIDAgMS02NC02NFYxOTJhNjQgNjQgMCAwIDEgNjQtNjRoMjE2LjV6TTEyOCAzMjB2NTEyaDc2OFYzMjBIMTI4eiBtMC02NGgyNDguNGwtMzEuOS02NEgxMjh2NjR6IiBmaWxsPSIjMCIgcC1pZD0iMjYwMCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Folder-outlined.svg
// module id = rzV6
// module chunks = 74